(function () {
  var PARALLAX_BREAKPOINT = 768;
  var observed = new Set();

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !observed.has(entry.target)) {
          observed.add(entry.target);
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  document
    .querySelectorAll('.hp-animate, .hp-line-draw')
    .forEach(function (el) {
      observer.observe(el);
    });

  var parallaxEls = Array.from(document.querySelectorAll('[data-parallax]'));

  if (parallaxEls.length) {
    var ticking = false;

    function updateParallax() {
      ticking = false;

      if (window.innerWidth <= PARALLAX_BREAKPOINT) {
        parallaxEls.forEach(function (el) {
          el.style.transform = '';
        });
        return;
      }

      var y = window.scrollY || window.pageYOffset || 0;
      var shift = (y * 0.3).toFixed(2);

      parallaxEls.forEach(function (el) {
        el.style.transform = 'translateY(' + shift + 'px)';
      });
    }

    function requestUpdate() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    updateParallax();
  }
})();
